import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import viewedStatusResponseAPI from '../../api/post-viewed-status-response';
import {
  postViewedStatusReceive,
  postViewedStatusReject,
  postViewedStatusRequested,
} from '../actions/admin-page';

interface IGetVacancyAction {
  type: string;
  payload: {
    responseId: string;
  }
}

const getViewedStatus = function* getViewedStatus(action: IGetVacancyAction) {
  try {
    yield call(viewedStatusResponseAPI, action.payload.responseId);
    yield put(postViewedStatusReceive());
  } catch (error) {
    yield put(postViewedStatusReject({ error }));
  }
};

export default function* getViewedStatusWatcher() {
  yield takeLatest(postViewedStatusRequested, getViewedStatus);
}
